/* eslint-disable fp/no-mutation */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatTextForConsent",
  standalone: true,
})
export class FormatTextForConsentPipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) {
      return "";
    }

    // Convert double-asterisk text (e.g., **Something bold**) to <strong> for bold
    value = value.replace(/\*\*(.+?)\*\*/g, "<p><strong>$1</strong></p>");

    // Convert single-asterisk lines (e.g., *This is header*) to emphasized headers, placing them outside of any list
    value = value.replace(/^\s*\*([^*]+)\*\s*$/gm, "<p><em>$1</em></p>");

    // Convert lines starting with a single asterisk or hyphen and space (`* ` or `- `) to list items
    value = value.replace(/^\s*[-*]\s(.+)/gm, "<li>$1</li>");

    // Wrap all <li> items in a single <ul> with breaks before and after if there are any <li> elements
    if (value.includes("<li>")) {
      value = value.replace(/(<li>[\s\S]*?<\/li>)/g, "<ul>$&</ul>");
      // Remove duplicate <ul> tags by capturing all <li> elements together in a single <ul>
      value = value.replace(/<\/ul>\s*<ul>/g, "");
      // Add <br> after </ul> to add spacing
      value = value.replace(/<\/ul>/, "</ul><br>");
    }

    // Wrap standalone lines that are not empty and do not start with other tags in <p> tags
    value = value.replace(/^(?!<(em|strong|ul|li)>)([^\n<>\s].+)$/gm, "<p>$2</p>");

    return value;
  }
}
